import {defineStore} from 'pinia'

// @ts-ignore
export const useHrStore = defineStore('hr', {
  state: () => ({
    pathPrefix: '/hr'
  }),
  getters: {},
  actions: {
    async getHrDataBoardList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?type=${payload.type}&page=${payload.page}&limit=${payload.limit}&dataType=${payload.dataType}&keyword=${payload.keyword}`
      const path = `${this.pathPrefix}/board/data${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getHrDataBoardDetail(hrId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/data/${hrId}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getHrKeywordList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?page=${payload.page}&limit=${payload.limit}&consonant=${payload.consonant}&keyword=${payload.keyword}`
      const path = `${this.pathPrefix}/keyword/${payload.type}${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },

    /**
     * 포토존 게시글 상세 조회
     * @returns {Promise<void>}
     */
    async getMonthlySeminarList(type) {
      const {$apiClient} = useNuxtApp()
      const query = `?type=${type}`
      const path = `${this.pathPrefix}/monthly${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 교육강좌 조회
     * @returns {Promise<void>}
     */
    async getSeminarList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?type=${payload.type}&page=${payload.page}&limit=${payload.limit}&status=${payload.status}`
      const path = `${this.pathPrefix}${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 교육강좌 상세 조회
     * @returns {Promise<void>}
     */
    async getSeminarDetail(seminarId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/${seminarId}`
      return await $apiClient(path, {
        method: 'GET'
      })
    }
  }
})
